import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AddSubregionAssignment, Subregion, SubregionAssignment } from '../loanofficerregionreference.model';
import { SubregionService } from '../subregions/subregions.service';

@Component({
  selector: 'app-subregion-add',
  templateUrl: './subregion-add.component.html',
  styleUrls: ['./subregion-add.component.css']
})
export class SubregionAddComponent implements OnInit {

    public SubregionAssignmentForm: FormGroup;
    public subregion: Subregion;
    public subregionAssignments: SubregionAssignment[];

    constructor(public dialogRef: MatDialogRef<SubregionAddComponent>, private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public subregionAssignmentName: string, private subregionService: SubregionService)
    { this.createForm(); }

    async ngOnInit() {
        var subregions = await this.subregionService.getSubregions();
        this.subregion = subregions.find(subregion => subregion.name == this.subregionAssignmentName);

        var otherSubregion = subregions.find(subregion => subregion.name != this.subregionAssignmentName);
        var currentSubregionAssignments = await this.subregionService.getSubregionAssignments(this.subregion.id);
        var otherSubregionAssignments = await this.subregionService.getSubregionAssignments(otherSubregion.id);
        this.subregionAssignments = currentSubregionAssignments.concat(otherSubregionAssignments);
    }

    createForm() {
        this.SubregionAssignmentForm = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(255)]]
        });
    }

    onSubmit() {
        if (!this.SubregionAssignmentForm.valid) {
            return;
        }
        const formModel = this.SubregionAssignmentForm.value;

        var existingAssignment = this.subregionAssignments.find(s => s.city == formModel.name);
        if (existingAssignment == undefined) {
            const saveSubregionAssignment: AddSubregionAssignment = {
                city: formModel.name as string,
                subregionId: this.subregion.id as string,
            };

            this.subregionService.addSubregionAssignments(saveSubregionAssignment)
                .then(result => this.dialogRef.close(result))
                .catch(error => console.log(error));
        }
        else {
            confirm('This branch is already allocated to a subregion of Ohio. you must add a unique branch name');
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/subregion-add/subregion-add.component.ts